import Head from 'next/head'

import { useSessionsLandingPageData } from './SessionsLandingPageDataProvider'

export const HeadTag = () => {
  const { session } = useSessionsLandingPageData()

  return (
    <Head>
      <title>{session.title}</title>
    </Head>
  )
}
